import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Miguel Valenzuela",
    when: "8 months ago",
    text: "Great communication and amazing work! Cleaned inside and out! Young man really putting in the work and it shows in the results. Can't wait for future business with him! 1000% recommend!",
  },
  {
    name: "Jonathan Quiles",
    when: "5 months ago",
    text: "Did a great job def call again and support this young man.",
    badge: "Local Guide",
  },
  {
    name: "Chris Rebollar",
    when: "5 months ago",
    text: "Excellent Work! Left my car spotless and only took a little bit!",
  },
  {
    name: "A. A.",
    when: "8 months ago",
    text: "Very satisfied and gets the job done.",
  },
];

function ReviewCard({ r }) {
  const initials = r.name
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div
      className="shrink-0 w-[340px] md:w-[400px] rounded-2xl border border-zinc-800 bg-zinc-900/40 backdrop-blur-md p-6 hover:border-cyan-500/40 transition-all"
      data-testid={`review-${r.name.split(" ")[0].toLowerCase()}`}
    >
      <Quote className="h-6 w-6 text-cyan-400/50 mb-3" />
      <p className="text-sm text-zinc-300 leading-relaxed">"{r.text}"</p>
      <div className="mt-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center text-zinc-950 font-bold text-sm">
            {initials}
          </div>
          <div>
            <div className="font-semibold text-sm">{r.name}</div>
            <div className="text-xs text-zinc-500">
              {r.badge ? `${r.badge} · ` : ""}
              {r.when}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-3.5 w-3.5 fill-cyan-400 text-cyan-400" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Reviews() {
  const looped = [...REVIEWS, ...REVIEWS];

  return (
    <section id="reviews" className="relative py-20 md:py-32 overflow-hidden border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-12">
          <div className="md:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400 mb-3">
              Word on the street
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter">
              <span className="text-cyan-400">5.0</span> on Google.
              <br />
              Earned, not bought.
            </h2>
          </div>
          <div className="md:col-span-5 md:text-right">
            <div className="inline-flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-cyan-400 text-cyan-400" />
              ))}
            </div>
            <div className="text-sm text-zinc-400">
              <span className="text-zinc-100 font-bold">15 verified reviews</span> · Real customers, real shine.
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative" data-testid="reviews-marquee">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-zinc-950 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-zinc-950 to-transparent z-10 pointer-events-none" />
        <div className="overflow-hidden no-scrollbar">
          <div className="flex gap-5 animate-marquee w-max">
            {looped.map((r, i) => (
              <ReviewCard key={i} r={r} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
